// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as ReactDebounce from "rescript-debounce-react/src/ReactDebounce.bs.js";
import * as Core from "@material-ui/core";
import * as User_Context$DvmAdminFrontendFr from "../../../../../context/user/User_Context.bs.js";
import * as App_Types_Result$DvmAdminFrontendFr from "../../../../../common/types/App_Types_Result.bs.js";
import * as App_Styles_Common$DvmAdminFrontendFr from "../../../../../common/styles/App_Styles_Common.bs.js";
import * as App_OverlaySpinner$DvmAdminFrontendFr from "../../../../../common/components/App_OverlaySpinner.bs.js";
import * as Messages_Orders_Detail$DvmAdminFrontendFr from "../../../../../intl/messages/orders/Messages_Orders_Detail.bs.js";
import * as Order_Detail_Reselling_Edits_Api$DvmAdminFrontendFr from "./Order_Detail_Reselling_Edits_Api.bs.js";
import * as Order_Detail_Reselling_Edits_Inputs_CompanyFormInput$DvmAdminFrontendFr from "./Order_Detail_Reselling_Edits_Inputs_CompanyFormInput.bs.js";

function Order_Detail_Reselling_Edits_Inputs_Sirets(Props) {
  var form = Props.form;
  var siretActiveResult = Props.siretActiveResult;
  var setSiretActiveResult = Props.setSiretActiveResult;
  var siretBudgetLLD = Props.siretBudgetLLD;
  var setSiretBudgetLLD = Props.setSiretBudgetLLD;
  var siretExists = Props.siretExists;
  var setSiretExists = Props.setSiretExists;
  var finalCustomerExists = Props.finalCustomerExists;
  var setFinalCustomerExists = Props.setFinalCustomerExists;
  var setFormConfirmDisable = Props.setFormConfirmDisable;
  var match = Curry._1(User_Context$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var match$1 = match[0];
  var userManager = match$1.userManager;
  var selectedRole = match$1.selectedRole;
  var match$2 = React.useState(function () {
        return /* NotStarted */0;
      });
  var match$3 = React.useState(function () {
        return /* NotStarted */0;
      });
  var match$4 = React.useState(function () {
        return /* NotStarted */0;
      });
  var setResultSiretName = match$4[1];
  var resultSiretName = match$4[0];
  var match$5 = React.useState(function () {
        return /* NotStarted */0;
      });
  var setResultFinalCustomerName = match$5[1];
  var resultFinalCustomerName = match$5[0];
  React.useEffect((function () {
          App_Types_Result$DvmAdminFrontendFr.mapWithDefault(siretActiveResult, undefined, (function (x) {
                  Curry._2(form.updateSiretActive, (function (input, siretActive) {
                          var newrecord = Caml_obj.obj_dup(input);
                          newrecord.siretActive = siretActive;
                          return newrecord;
                        }), x);
                }));
        }), [siretActiveResult]);
  React.useEffect((function () {
          App_Types_Result$DvmAdminFrontendFr.mapWithDefault(siretBudgetLLD, undefined, (function (x) {
                  Curry._2(form.updateSiretBudgetLLD, (function (input, siretBudgetLLD) {
                          var newrecord = Caml_obj.obj_dup(input);
                          newrecord.siretBudgetLLD = siretBudgetLLD;
                          return newrecord;
                        }), x);
                }));
        }), [siretBudgetLLD]);
  React.useEffect((function () {
          App_Types_Result$DvmAdminFrontendFr.mapWithDefault(siretExists, undefined, (function (exists) {
                  if (exists) {
                    Order_Detail_Reselling_Edits_Api$DvmAdminFrontendFr.checkSiretActive(userManager, setSiretActiveResult, selectedRole, form.input.siret);
                    Order_Detail_Reselling_Edits_Api$DvmAdminFrontendFr.checkSiretBudgetLLD(userManager, setSiretBudgetLLD, selectedRole, form.input.siret);
                  }
                  Curry._2(form.updateSiretExists, (function (input, siretExists) {
                          var newrecord = Caml_obj.obj_dup(input);
                          newrecord.siretExists = siretExists;
                          return newrecord;
                        }), exists);
                }));
        }), [siretExists]);
  React.useEffect((function () {
          App_Types_Result$DvmAdminFrontendFr.mapWithDefault(finalCustomerExists, undefined, (function (exists) {
                  Curry._2(form.updateFinalCustomerExists, (function (input, finalCustomerExists) {
                          var newrecord = Caml_obj.obj_dup(input);
                          newrecord.finalCustomerExists = finalCustomerExists;
                          return newrecord;
                        }), exists);
                }));
        }), [finalCustomerExists]);
  React.useEffect((function () {
          App_Types_Result$DvmAdminFrontendFr.mapWithDefault(resultSiretName, undefined, (function (x) {
                  Belt_Option.mapWithDefault(x, undefined, Curry._1(form.updateSiretName, (function (input, siretName) {
                              var newrecord = Caml_obj.obj_dup(input);
                              newrecord.siretName = siretName;
                              return newrecord;
                            })));
                }));
        }), [resultSiretName]);
  React.useEffect((function () {
          App_Types_Result$DvmAdminFrontendFr.mapWithDefault(resultFinalCustomerName, undefined, (function (x) {
                  Belt_Option.mapWithDefault(x, undefined, Curry._1(form.updateSirenNameFinalCustomer, (function (input, sirenNameFinalCustomer) {
                              var newrecord = Caml_obj.obj_dup(input);
                              newrecord.sirenNameFinalCustomer = sirenNameFinalCustomer;
                              return newrecord;
                            })));
                }));
        }), [resultFinalCustomerName]);
  var checkSiret = function (siret) {
    if (form.input.siret.length > 0) {
      Order_Detail_Reselling_Edits_Api$DvmAdminFrontendFr.checkSiretExists(userManager, setSiretExists, selectedRole, siret);
      return Order_Detail_Reselling_Edits_Api$DvmAdminFrontendFr.getCompanyName(userManager, setResultSiretName, selectedRole, form.input.siret, "siret");
    }
    
  };
  var checkFinalCustomer = function (finalCustomer) {
    if (form.input.finalCustomer.length > 0) {
      Order_Detail_Reselling_Edits_Api$DvmAdminFrontendFr.checkSirenExists(userManager, setFinalCustomerExists, selectedRole, finalCustomer);
      return Order_Detail_Reselling_Edits_Api$DvmAdminFrontendFr.getCompanyName(userManager, setResultFinalCustomerName, selectedRole, form.input.finalCustomer, "siren");
    }
    
  };
  var debounceSiret = ReactDebounce.useDebounced(1000, checkSiret);
  var debounceFinalCustomer = ReactDebounce.useDebounced(1000, checkFinalCustomer);
  return React.createElement(React.Fragment, undefined, React.createElement(Core.Grid, {
                  children: React.createElement(App_OverlaySpinner$DvmAdminFrontendFr.make, {
                        show: App_Types_Result$DvmAdminFrontendFr.isPending(siretExists) || App_Types_Result$DvmAdminFrontendFr.isPending(siretActiveResult) || App_Types_Result$DvmAdminFrontendFr.isPending(siretBudgetLLD) || App_Types_Result$DvmAdminFrontendFr.isPending(resultSiretName),
                        children: React.createElement(Order_Detail_Reselling_Edits_Inputs_CompanyFormInput$DvmAdminFrontendFr.make, {
                              onChange: (function (siret) {
                                  Curry._1(debounceSiret, siret);
                                  Curry._2(form.updateSiret, (function (input, siret) {
                                          var newrecord = Caml_obj.obj_dup(input);
                                          newrecord.siret = siret;
                                          return newrecord;
                                        }), siret.trim());
                                }),
                              value: form.input.siret,
                              validationResult: form.siretResult,
                              companies: match$2[0],
                              setCompanies: match$2[1],
                              className: App_Styles_Common$DvmAdminFrontendFr.Inputs.longInput,
                              companyType: "siret",
                              onBlur: (function (param) {
                                  Curry._1(setFormConfirmDisable, (function (param) {
                                          return false;
                                        }));
                                  checkSiret(form.input.siret);
                                }),
                              onFocus: (function (param) {
                                  Curry._1(setFormConfirmDisable, (function (param) {
                                          return true;
                                        }));
                                })
                            })
                      }),
                  item: true
                }), React.createElement(Core.Grid, {
                  children: React.createElement(App_OverlaySpinner$DvmAdminFrontendFr.make, {
                        show: App_Types_Result$DvmAdminFrontendFr.isPending(finalCustomerExists) || App_Types_Result$DvmAdminFrontendFr.isPending(siretActiveResult) || App_Types_Result$DvmAdminFrontendFr.isPending(siretBudgetLLD) || App_Types_Result$DvmAdminFrontendFr.isPending(resultFinalCustomerName),
                        children: React.createElement(Order_Detail_Reselling_Edits_Inputs_CompanyFormInput$DvmAdminFrontendFr.make, {
                              onChange: (function (siren) {
                                  Curry._1(debounceFinalCustomer, siren);
                                  Curry._2(form.updateFinalCustomer, (function (input, finalCustomer) {
                                          var newrecord = Caml_obj.obj_dup(input);
                                          newrecord.finalCustomer = finalCustomer;
                                          return newrecord;
                                        }), siren.trim());
                                }),
                              value: form.input.finalCustomer,
                              validationResult: form.finalCustomerResult,
                              companies: match$3[0],
                              setCompanies: match$3[1],
                              className: App_Styles_Common$DvmAdminFrontendFr.Inputs.longInput,
                              companyType: "siren",
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.finalCustomer,
                              onBlur: (function (param) {
                                  Curry._1(setFormConfirmDisable, (function (param) {
                                          return false;
                                        }));
                                  checkFinalCustomer(form.input.finalCustomer);
                                }),
                              onFocus: (function (param) {
                                  Curry._1(setFormConfirmDisable, (function (param) {
                                          return true;
                                        }));
                                })
                            })
                      }),
                  item: true
                }));
}

var Api;

var Form;

var InputStyles;

var make = Order_Detail_Reselling_Edits_Inputs_Sirets;

export {
  Api ,
  Form ,
  InputStyles ,
  make ,
}
/* react Not a pure module */
